import template from './ko-render-field-text.html';

class TextInputComponentVM
{
	constructor(params)
	{
		this.params = params;

		this.readonly = ko.observable();
		this.name = ko.observable(params.name);
		this.label = ko.observable(params.label);
		this.hide_labels = ko.observable(params.hide_labels);
		this.$input = params.$input;
		this.multiline = ko.observable(false);
		this.rows = ko.observable();
		this.help_text = ko.observable(params.help_text);
		this.required = ko.observable(false);

		if (params.type == 'text_readonly')
			this.readonly(true);
		else
			this.readonly(false);

		if (params.ui_fields)
		{
			this.multiline(params.ui_fields.multiline);
			this.rows(params.ui_fields.rows);
			this.required(params.ui_fields.required);
		}
		else
		{
			if (params.rows)
				this.rows(params.rows);
			if (params.multiline)
				this.multiline(params.multiline);
			if (params.required)
				this.required(params.required);
		}
	}
}


export default {
	name: 'ko-render-field-text',
	viewModel: TextInputComponentVM,
	module_type: 'ko',
	template: template
}
